import React from "react";
import { motion } from "framer-motion";
import { Percent, Layers, Scale, LineChart, Handshake, Target } from "lucide-react";
import CTAButton from "./CTAButton";
const items = [
  { icon: Percent, t: "Sem juros bancários", d: "A única modalidade de crédito imobiliário sem juros. Você paga apenas a taxa de administração, diluída." },
  { icon: Layers, t: "Diversificação patrimonial", d: "Imóveis são a base silenciosa de grandes fortunas. Estruturamos aquisições com previsibilidade." },
  { icon: Scale, t: "Planejamento tributário", d: "O consórcio como ferramenta fiscal e de proteção patrimonial, dentro da legalidade." },
  { icon: LineChart, t: "Análise personalizada", d: "Cada tese recebe estudo completo de viabilidade alinhado ao seu plano de vida." },
  { icon: Handshake, t: "Atendimento exclusivo", d: "Consultoria individual — sem esteira, sem script, sem pressão. Foco em estratégia." },
  { icon: Target, t: "Contemplação acelerada", d: "Técnicas de lance e formatação que, historicamente, reduzem o tempo de espera." },
];
export default function Benefits() {
  return (
    <section id="vantagens" className="py-24 lg:py-32 relative" data-testid="benefits">
      <div className="container">
        <div className="max-w-3xl mb-16">
          <div className="eyebrow mb-4"><span className="kicker-line"/>Vantagens</div>
          <h2 className="text-4xl md:text-5xl font-display font-light">Por que investidores escolhem <span className="italic text-gold-gradient">o consórcio estratégico</span>.</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border">
          {items.map((it, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
              className="bg-background hover:bg-card-gradient p-8 group transition-colors">
              <div className="flex items-start justify-between mb-6">
                <it.icon className="text-primary" size={28}/>
                <span className="font-mono text-[10px] text-muted-foreground">0{i+1}</span>
              </div>
              <h3 className="font-display text-xl mb-3 group-hover:text-primary transition-colors">{it.t}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{it.d}</p>
            </motion.div>
          ))}
        </div>
        <CTAButton centered />
      </div>
    </section>
  );
}
